module.exports = __webpack_public_path__ + "static/media/fishman giving.f0f3c397.gif";